import React from 'react';
import styles from '../accountDetails.module.css';
import { tWithKeyAttr as t } from "../../../../i18nHelper";

interface NotificationsTabProps {
}

export const NotificationsTab: React.FC<NotificationsTabProps> = () => {
  return (
    <div className={styles.notificationsContent}>
      <h2>{t("NOTIFICATIONS")}</h2>
    </div>
  );
};
